import { getGenericStore } from './genericStore';

const selectedBrickIDsStore = Object.create(getGenericStore([]));
export default selectedBrickIDsStore;